<template>
  <main :class="['v-view-primary',
    ($store.getters.getAcademyData.persona === undefined && $store.getters.getAcademyData.is_licencia_paga) ||
    ($store.getters.getAcademyDaysLeft !== null && !$store.getters.getAcademyData.is_licencia_paga)
      ? 'v-view-primary-upgrade' : '']">
    <OrganismTheHeader/>
    <section class="v-edition-section">
      <OrganismEditionSectionInfo
        :element-name="elementName"
        :go-back-text="goBackText"
        :info-title="infoTitle"
        :info-sub-title="infoSubTitle"
        :show-loading-state="showLoadingState"
        :subject="subject"
      />
      <OrganismEditionSectionNavigation
        :contenido="contenido"
        :element="element"
        :show-loading-state="showLoadingState"
      />
      <OrganismEditionSectionContent
        :element="element"
        :element-categorias="elementCategorias"
        :molecule="molecule"
        :section="section"
        :show-loading-state="showLoadingState"
        :subject="subject"
        :subedition="subedition"
      />
    </section>
  </main>
</template>

<script>
export default {
  name: 'EditionSection',

  components: {
    OrganismEditionSectionInfo: () => import('@/components/organisms/OrganismEditionSectionInfo'),
    OrganismEditionSectionNavigation: () => import('@/components/organisms/OrganismEditionSectionNavigation'),
    OrganismEditionSectionContent: () => import('@/components/organisms/OrganismEditionSectionContent')
  },

  data () {
    return {
      contenido: '',
      element: {},
      elementCategorias: [],
      goBackText: '',
      infoTitle: '',
      infoSubTitle: '',
      molecule: '',
      showLoadingState: 0,
      subject: '',
      subedition: '',
      subitem: ''
    }
  },

  computed: {
    elementName () {
      return this.isAnAssetRoute || this.isAnMapRoute
        ? this.element.titulo
        : this.element.nombre
    },

    isAnAssetRoute () {
      return this.$route.meta.isEdition === 'assets' ||
        this.$route.meta.isEdition === 'asset' ||
        this.$route.meta.isEdition === 'map' ||
        this.$route.meta.isEdition === 'maps'
    },

    section () {
      return this.$utils.stringCapitalized(this.$route.meta.isEdition)
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    $route (to, from) {
      this.getMolecule()
      this.$utils.hideAsideNavigationMenu()
    },

    '$route.params.id' () {
      this.readElement()
    },

    updatedData () {
      if (this.$modal.methodToRun === 'readElement') {
        this.readElement()
      }
    }
  },

  created () {
    this.getMolecule()
    this.readElement()
    this.$utils.hideAsideNavigationMenu()
  },

  methods: {
    getMolecule () {
      this.setInitialStates()
      let menu = this.$i18n.messages[this.$i18n.locale].mEditionMenu[this.$route.meta.isEdition]
      for (const item in menu) {
        if (menu[item].subject === this.$route.params.subject) {
          this.infoTitle = menu[item].text
          this.subject = this.$utils.stringCapitalized(item)
          for (const child in menu[item].children) {
            if (menu[item].children[child].subedition === this.$route.params.subedition) {
              this.goBackText = menu[item].children[child].goBackText
              this.infoSubTitle = menu[item].children[child].text
              this.subedition = this.$utils.stringCapitalized(child)
              for (const subChild in menu[item].children[child].children) {
                if (menu[item].children[child].children[subChild].subitem === this.$route.params.subitem) {
                  this.goBackText = menu[item].children[child].children[subChild].goBackText
                  this.infoSubTitle = menu[item].children[child].children[subChild].text
                  this.subitem = this.$utils.stringCapitalized(subChild)
                  break
                }
              }
              break
            }
          }
          break
        }
      }

      this.molecule = this.$route.params.subitem
        ? () => import(`@/components/molecules/MoleculeEdition${this.section}${this.subject}${this.subedition}${this.subitem}`)
        : this.$route.params.subedition
          ? () => import(`@/components/molecules/MoleculeEdition${this.section}${this.subject}${this.subedition}`)
          : () => import(`@/components/molecules/MoleculeEdition${this.section}${this.subject}`)

      this.showLoadingState++
    },

    readElement () {
      if (this.$route.meta.isEdition === 'asset' || this.$route.meta.isEdition === 'map') {
        this.readProyecto()
        this.readProyectoCategorias()
        this.readContenidos()
      } else if (this.$route.meta.isEdition === 'product') {
        this.readProducto()
        this.readProductoCategorias()
        this.showLoadingState++
      } else {
        this.showLoadingState += 4
      }
    },

    readContenidos () {
      this.$services.read('contenido', 'readContenidos', {}, [this.$route.params.id])
        .then(response => {
          // contenido (versión) creada by default al crear el proyecto
          this.contenido = response.data[0].id
          this.$store.commit('setAssetContents', response.data)
          this.readContenidoNodos()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readContenidoNodos () {
      this.$services.read('contenido', 'readContenidoNodos', {}, [this.contenido])
        .then(response => {
          this.$store.commit('setAssetNodes', response.data)
          if (response.data.length && (!Object.keys(this.$store.getters.getAssetSelectedNode).length ||
            this.$store.getters.getAssetSelectedNode.contenido !== this.contenido)) {
            this.$store.commit('setAssetSelectedNode', response.data[0])
          } else if (!response.data.length) {
            this.$store.commit('unsetAssetSelectedNode')
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readProducto () {
      this.$services.read('producto', 'readProducto', {}, [this.$route.params.id])
        .then(response => {
          this.element = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readProductoCategorias () {
      this.$services.read('producto', 'readProductoCategorias')
        .then(response => {
          this.elementCategorias = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readProyecto () {
      this.$services.read('proyecto', 'readProyecto', {}, [this.$route.params.id])
        .then(response => {
          this.element = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readProyectoCategorias () {
      this.$services.read('proyecto', 'readProyectoCategorias')
        .then(response => {
          this.elementCategorias = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    setInitialStates () {
      this.infoTitle = ''
      this.infoSubTitle = ''
      this.goBackText = ''
      this.subject = ''
      this.subedition = ''
      this.subitem = ''
    }
  }
}
</script>
